import { formatPrice } from "../packagePricing";

export const PRICE_DISPLAY = {
  EXACT: "exact",
  RANGE: "range",
  HIDDEN: "hidden",
} as const;

export type PriceDisplay = typeof PRICE_DISPLAY[keyof typeof PRICE_DISPLAY];

export const RANGE_FLOOR_FACTOR = 0.8;
export const RANGE_CEILING_FACTOR = 1.3;

export const PRICE_HIDDEN_THANK_YOU_MESSAGE =
  "Your answers have been received. Watch your email. We will reach out shortly.";

// Anything other than a known mode falls back to exact, so this screen keeps today's
// behaviour while the backend that serves price_display is not deployed.
export const getPriceDisplay = (cpaDetail: any): PriceDisplay => {
  const value = cpaDetail?.survey_setting?.data?.attributes?.price_display;
  if (value === PRICE_DISPLAY.RANGE || value === PRICE_DISPLAY.HIDDEN) {
    return value;
  }
  return PRICE_DISPLAY.EXACT;
};

export const formatDisplayedPrice = (
  price: number,
  priceDisplay: PriceDisplay
): string => {
  if (priceDisplay === PRICE_DISPLAY.RANGE) {
    return `$ ${formatPrice(price * RANGE_FLOOR_FACTOR)} - $ ${formatPrice(
      price * RANGE_CEILING_FACTOR
    )}`;
  }
  return `$ ${formatPrice(price)}`;
};
